module.exports = __webpack_public_path__ + "img/91.af6b5ca2.jpg";